import { PHONE_NUMBER } from '@/constants/Common'
import { LocalePerformance } from '../en/performance'

const performance: LocalePerformance = {
  myPerformance: 'Prestasi Saya',
  wins: 'Kemenangan',
  losses: 'Kekalahan',
  avgPoints: 'Purata Mata',
  avgPts: 'Purata Pt',
  avgPartner: 'Purata Rakan',
  avgPtr: 'Purata Ptr',
  avgOpponent: 'Purata Lawan',
  win: 'Menang',
  loss: 'Kalah',
  reject: 'Tolak',
  validate: 'Sahkan',
  validateMatch: 'Sahkan Perlawanan',
  confirmValidateMatch:
    'Adakah anda pasti bahawa anda ingin mengesahkan skor ini? Jika ya, perlawanan akan dimuktamadkan dan penarafan pemain akan dikemas kini.',
  matchSourceLeague: `Jika skor ini tidak betul, sila hubungi pengarah acara atau teks ${PHONE_NUMBER} dengan skor yang betul.`,
  deleteMatchConfirm:
    'Jika anda memadam perlawanan ini, anda perlu bermula semula untuk memasukkan skor dan mempengaruhi penarafan anda.',
  halfLife: 'Separuh Hayat',
  avgOpp: 'Purata Lawan',
  matchesEmpty: 'Anda belum bermain sebarang perlawanan lagi!',
  matchesEmptyDes: 'Cari beberapa pemain untuk bermain dan mulakan perjalanan anda!',
}

export default performance
